export default function SVG_Reference() {
  return (
    <div>
      <h1>SVG_Reference Component</h1>
    </div>
  );
}
